module.exports = __webpack_public_path__ + "img/QRcode12.ea87d29d.png";